import type { Member } from '~/types/auth';

export const getProfileApi = async (): Promise<Member> => {
  const response = await useApiFetch('/profile', {
    method: 'GET',
    requireAuth: true,
  });
  return await response.json();
};

export const putProfileApi = async (data: Member): Promise<Member> => {
  const response = await useApiFetch('/profile', {
    method: 'PUT',
    requireAuth: true,
    body: JSON.stringify(data),
  });
  return await response.json();
};
